import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { getSoarApiUrl, sendMessage } from '../../shared/helpers/request-helper';
import ContactForm from '../../shared/components/forms/contact-form';
import { UserRecord } from '../../shared/records/user-record';
import '../styles/contact.scss';

export const emptyUser = new UserRecord();

const loader = (
  <div className="container contact__loader">
    <i className="fa fa-spinner fa-pulse" />
  </div>
);
class Contact extends Component {
  static propTypes = {
    user: PropTypes.instanceOf(UserRecord),
    contactUrl: PropTypes.string.isRequired,
    isLoading: PropTypes.bool,
    errorMessage: PropTypes.string,
    successMessage: PropTypes.string,
    setConfig: PropTypes.func.isRequired,
    setErrorMessage: PropTypes.func.isRequired,
    setSuccessMessage: PropTypes.func.isRequired,
    fetchUserData: PropTypes.func.isRequired,
  };

  static defaultProps = {
    user: emptyUser,
    isLoading: false,
    errorMessage: '',
    successMessage: '',
  };

  componentDidMount() {
    const { setConfig, setErrorMessage, fetchUserData } = this.props;

    try {
      const soarApiHost = getSoarApiUrl();
      const userIdElem = document.getElementById('user-id');
      const userId = userIdElem ? userIdElem.value : null;

      setConfig({ SOAR_API_HOST: soarApiHost });
      fetchUserData(userId);
    } catch (error) {
      // eslint-disable-next-line no-console
      setErrorMessage(`Something went wrong. Try the operation again. Error: ${error.message}`);
    }
  }

  handleSubmitSendMessage = (values) => {
    const { contactUrl, setErrorMessage, setSuccessMessage } = this.props;
    const { givenName, familyName, emailAddress, phoneNumber, message, reason } = values;
    const payload = JSON.stringify({
      givenName,
      familyName,
      emailAddress,
      phone: phoneNumber,
      message,
      reason,
    });

    const successCallback = () => {
      setSuccessMessage('We have sent your message.');
    };

    const failureCallback = (error) => {
      setErrorMessage(`Something went wrong. Try the operation again. Error: ${error.message}`);
    };

    sendMessage(contactUrl, payload, successCallback, failureCallback);
  };

  render() {
    const { isLoading, errorMessage, successMessage, user } = this.props;

    if (isLoading) {
      return loader;
    }

    return (
      <>
        {errorMessage && (
          <div className="contact__message">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <p className="alert alert-danger">{errorMessage}</p>
                </div>
              </div>
            </div>
          </div>
        )}
        {successMessage && (
          <div className="contact__message">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <p className="alert alert-success">{successMessage}</p>
                </div>
              </div>
            </div>
          </div>
        )}
        <ContactForm
          onSubmit={this.handleSubmitSendMessage}
          initialValues={user.toObject()}
          title="Send us a message"
          isShowReason
        />
      </>
    );
  }
}

export default Contact;
